export const required = [
    { key : "strFirstName" , value: 'M0001' },
    { key : "strLastName" , value: 'M0004' },
    { key : "dtDateOfBirth" , value: 'M0009' },
    { key : "strSSNNumber" , value: 'M0011'},
    { key : "dtFingerprintSubmissionDate" , value: 'M0141' },
    { key : "strFingerprintSubmissionMethod" , value: 'M0142' },
    { key : "strTcnNumber" , value: 'M0143' },
]
export const pattern = [
    { key : "strFirstName" , value: 'M0002' },
    { key : "strLastName" , value: 'M0005' },
    { key : "dtDateOfBirth" , value: 'M0010' },
    { key : "primary_email" , value: 'M0015' },
    { key : "strTcnNumber" , value: 'M0155' },
    { key : "dtFingerprintSubmissionDate" , value: 'M0064' },
]

export const errorMessages = {
}